import { Fragment } from "react";

import AssetMap from "./AssetMap";
import AssetList from "../AssetList";

function MapView() {
  return (
    <Fragment>
      <AssetMap />
      <AssetList />
    </Fragment>
  );
}

export default MapView;
